import { useCallback, useState } from "react";
import tabTatca from "../assets/tab-tatca.svg";
import tabResult from "../assets/tab-result.svg";
import hotIcon from "../assets/hot-icon.svg";
import liveGif from "../assets/icon_truc_tiep.gif";
import filterIcon from "../assets/filter.svg";
import MatchBoard from "./MatchBoard";
import "./home-center.css";

const TABS = [
  { id: "tatca", label: "Lịch thi đấu", icon: tabTatca },
  { id: "ketqua", label: "Kết quả", icon: tabResult },
  { id: "hot", label: "Tâm Điểm", icon: hotIcon },
  { id: "tructuyen", label: "Trực Tuyến", icon: liveGif },
];

export default function HomeCenter() {
  const [activeTab, setActiveTab] = useState("hot");
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  const onFilterClose = useCallback(() => setFilterOpen(false), []);
  const onFilterApplied = useCallback((hasFilter) => setFilterActive(Boolean(hasFilter)), []);

  return (
    <div className="kbv-home kbv-home-center">
      <div className="kbv-home-center__tabs" role="tablist" aria-label="Bảng kèo">
        {TABS.map((tab) => {
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              className={`kbv-home-center__tab${active ? " is-active" : ""}`}
              onClick={() => {
                setActiveTab(tab.id);
                setFilterActive(false);
                setFilterOpen(false);
              }}
            >
              <span className="kbv-home-center__tab-inner">
                <img className="kbv-home-center__tab-icon" src={tab.icon} alt="" />
                <span className="kbv-home-center__tab-label">{tab.label}</span>
              </span>
              {active ? <span className="kbv-home-center__tab-underline" aria-hidden="true" /> : null}
            </button>
          );
        })}
        <button
          type="button"
          className="kbv-home-center__filter"
          aria-label="Lọc giải đấu"
          onClick={() => setFilterOpen(true)}
        >
          <img src={filterIcon} alt="" />
          {filterActive ? <span className="kbv-home-center__filter-dot" aria-hidden="true" /> : null}
        </button>
      </div>

      <div className="kbv-home-center__body" role="tabpanel">
        <MatchBoard
          key={activeTab}
          type={activeTab}
          filterOpen={filterOpen}
          onFilterClose={onFilterClose}
          onFilterApplied={onFilterApplied}
        />
      </div>
    </div>
  );
}
